import { PropsWithChildren, useMemo } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import {
  CampaignMappingsDataContext,
  CampaignMappingsDataContextType,
} from './CampaignMappingsDataContext';
import {
  useCampaignMappingsColumnsQuery,
  useCampaignMappingsQuery,
} from 'src/api/campaignMappings';

export function CampaignMappingsDataContextProvider(props: PropsWithChildren) {
  const { currentCustomer } = useAppContext();

  const {
    data,
    isLoading: isLoadingCampaignMappings,
    isError: isErrorCampaignMappings,
  } = useCampaignMappingsQuery(
    currentCustomer?.customerName ?? 'missing_customer',
  );

  const {
    data: columnsData,
    isLoading: isLoadingColumns,
    isError: isErrorColumns,
  } = useCampaignMappingsColumnsQuery(
    currentCustomer?.customerName ?? 'missing_customer',
  );

  const value = useMemo<CampaignMappingsDataContextType>(() => {
    return {
      // Data
      campaignMappingsData: data ?? [],
      columns: columnsData ?? [],
      // Loading states
      isLoadingCampaignMappings: isLoadingCampaignMappings || isLoadingColumns,
      isErrorCampaignMappings: isErrorCampaignMappings || isErrorColumns,
    };
  }, [
    data,
    columnsData,
    isLoadingCampaignMappings,
    isLoadingColumns,
    isErrorCampaignMappings,
    isErrorColumns,
  ]);

  return (
    <CampaignMappingsDataContext.Provider value={value}>
      {props.children}
    </CampaignMappingsDataContext.Provider>
  );
}
